import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ActionIconButton({
  icon,
  label,
  variant = 'outline-secondary',
  className = '',
  children,
  ...props
}) {
  return (
    <Button
      {...props}
      variant={variant}
      className={`erp-action-btn ${className}`.trim()}
      title={label}
      aria-label={label}
    >
      {icon ? <FontAwesomeIcon icon={icon} /> : children}
    </Button>
  );
}

export default ActionIconButton;
